import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap, filter } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { contributorsList } from '../selectors';
import { UPDATE_TRACK_FIELD } from '../../tracks/actions';
import { UpdateTrackField } from '../../tracks/action-creators';
import { CreateCollaborator, UpdateCollaborator } from '../action-creators';

/**
 *
 * This effect adds Tracks' lyricist if the song is non-instrumental
 *
 */

export const createLyricistCreditForSongsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, UpdateTrackField<'type'>>(UPDATE_TRACK_FIELD),
    withLatestFrom(state$),
    filter(([action, state]) => {
      return (
        action.field === 'type' &&
        action.value === 'song' &&
        contributorsList(state.collaborator, action.trackId).filter((c) =>
          c.role.includes('Lyricist')
        ).length === 0
      );
    }),
    concatMap(([action, state]) => {
      const actions: Action[] = [];
      const userAsCredit = contributorsList(
        state.collaborator,
        action.trackId
      ).find((c) => c.collaboratorId === state.user.profile?.id);
      if (userAsCredit) {
        actions.push(
          new UpdateCollaborator({
            ...userAsCredit,
            role: `${userAsCredit.role},Lyricist`,
          })
        );
      }
      if (!userAsCredit) {
        actions.push(
          new CreateCollaborator({
            name: state.user?.profile?.fullName,
            assetId: action.trackId,
            assetType: 'TRACK',
            collaboratorType: 'USER',
            collaboratorId: state.user.profile?.id,
            role: 'Lyricist',
            type: 'CONTRIBUTOR',
            contact: state.user.profile?.email || '',
            avatar: state.user.profile?.avatar,
            releaseId: state.release.release?.id,
          })
        );
      }
      return actions;
    })
  );
